"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environmentsRequestFailure = exports.environmentsRequestSuccess = exports.environmentsRequest = exports.scopesRequestFailure = exports.scopesRequestSuccess = exports.scopesRequest = exports.applicationRequestFailure = exports.applicationRequestSuccess = exports.applicationRequest = void 0;

var _constants = require("./constants");

var applicationRequest = function applicationRequest(payload) {
  return {
    type: _constants.ApplicationType.APPLICATION_REQUEST,
    payload: payload
  };
};

exports.applicationRequest = applicationRequest;

var applicationRequestSuccess = function applicationRequestSuccess(payload) {
  return {
    type: _constants.ApplicationType.APPLICATION_SUCCESS,
    payload: payload
  };
};

exports.applicationRequestSuccess = applicationRequestSuccess;

var applicationRequestFailure = function applicationRequestFailure(reason) {
  return {
    type: _constants.ApplicationType.APPLICATION_FAILURE,
    payload: reason
  };
};

exports.applicationRequestFailure = applicationRequestFailure;

var scopesRequest = function scopesRequest(payload) {
  return {
    type: _constants.ScopesType.SCOPES_REQUEST,
    payload: payload
  };
};

exports.scopesRequest = scopesRequest;

var scopesRequestSuccess = function scopesRequestSuccess(payload) {
  return {
    type: _constants.ScopesType.SCOPES_SUCCESS,
    payload: payload
  };
};

exports.scopesRequestSuccess = scopesRequestSuccess;

var scopesRequestFailure = function scopesRequestFailure(reason) {
  return {
    type: _constants.ScopesType.SCOPES_FAILURE,
    payload: reason
  };
};

exports.scopesRequestFailure = scopesRequestFailure;

var environmentsRequest = function environmentsRequest(payload) {
  return {
    type: _constants.EnvironmentsType.ENVIRONMENTS_REQUEST,
    payload: payload
  };
};

exports.environmentsRequest = environmentsRequest;

var environmentsRequestSuccess = function environmentsRequestSuccess(payload) {
  return {
    type: _constants.EnvironmentsType.ENVIRONMENTS_SUCCESS,
    payload: payload
  };
};

exports.environmentsRequestSuccess = environmentsRequestSuccess;

var environmentsRequestFailure = function environmentsRequestFailure(reason) {
  return {
    type: _constants.EnvironmentsType.ENVIRONMENTS_FAILURE,
    payload: reason
  };
};

exports.environmentsRequestFailure = environmentsRequestFailure;